import { api } from './client.js';

const root = '/admin/operations';

export const operationsApi = {
  summary: () => api.get(`${root}/summary`)
};
